import React from 'react';
import { compose, pipe, reduce, set, lensProp, values } from 'ramda';
import styleFile from './EngineRoomInfo.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { RichText } from '@synergycms_core/components/generic/';

export default compose(withThemeJSS({ displayName: 'EngineRoomInfo', styleFile }))(props => {
  const { theme, occups } = props;
  const { classes } = theme.styles;

  const arrayOccups = values(occups);
  const adultsKey = lensProp('adults');
  const childsKey = lensProp('childs');
  const parsedOccups = reduce(
    (occupsCounter, occup) => {
      return pipe(
        set(adultsKey, occupsCounter.adults + occup.adults || 0),
        set(childsKey, occupsCounter.childs + occup.childs || 0)
      )(occupsCounter);
    },
    { adults: 0, childs: 0 },
    arrayOccups
  );

  return (
    <div>
      {parsedOccups.adults && (
        <div className={theme.computedInnerStyle}>
          <RichText text={parsedOccups.adults} />{' '}
          <RichText translate={true} ucFirst={true} quantity={parsedOccups.adults} text={'_%adulto%_'} />
        </div>
      )}
      {parsedOccups.childs > 0 && (
        <div className={theme.computedInnerStyle}>
          {' '}
          <RichText translate={true} ucFirst={true} quantity={parsedOccups.childs} text={parsedOccups.childs} />{' '}
          <RichText translate={true} ucFirst={true} quantity={parsedOccups.childs} text={'_%niño%_'} />
        </div>
      )}
      <div className={theme.computedInnerStyle}>
        <span aria-hidden={true}>{' - '}</span>
        <RichText text={arrayOccups.length} />{' '}
        <RichText translate={true} plural={true} ucFirst={true} quantity={arrayOccups.length} text={'_%habitación%_'} />
      </div>
    </div>
  );
});
